export default [
    {
        path: '/rack/without-cluster-list',
        name: 'racks_without_cluster_list',
        component: () => import('@src/rack/rack-without-cluster-list.vue'),
        meta: {
            title: 'Noch nicht zugeordnete Regale',
            role: 'ROLE_CLUSTER_MANAGEMENT',
        },
    },
];
